import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { createBetfairCheckoutSession } from '../services/stripeService';
import './SubscribePage.css';
import './auth/AuthPages.css';

/**
 * Public route: 14-day Betfair trial (email → API trial → /register).
 * Legacy /start-checkout redirects here.
 */
const MarketingCheckoutStart: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const url = await createBetfairCheckoutSession(email);
      window.location.href = url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not start trial');
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src="/dark_favicon_logo.png" alt="GallopAI" className="auth-logo" />
          <h1>Start your 14-day free trial</h1>
          <p>
            Enter your email to begin. No payment details required — full access for 14 days.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="betfair-trial-email">Email address</label>
            <input
              id="betfair-trial-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
              autoComplete="email"
              disabled={submitting}
            />
          </div>

          <button type="submit" disabled={submitting || !email.trim()} className="auth-button primary">
            {submitting ? 'Starting trial…' : 'Start free trial'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            <Link to="/" className="auth-link">
              Back to homepage
            </Link>
            {' · '}
            <Link to="/resume-signup" className="auth-link">
              Already started?
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketingCheckoutStart;
